import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import { TransitionProps } from '@material-ui/core/transitions'


import { Button } from '.'


export interface ConfirmBoxProps {
    Open: boolean;
    Title: string;
    Message: string;
    OkButtonText: string;
    CancelButtonText: string;
    OnButtonClick: (ButtonClicked: string) => void;
}

//@ts-ignore
const Transition = React.forwardRef<HTMLElement, TransitionProps>((props, ref) => <Slide direction="up" ref={ref} {...props} />);
export enum ConfirmBoxResult {
    OK = "OK",
    Cancel = "Cancel"
}
export default function ConfirmBox(props: ConfirmBoxProps) {
    const {
        Open,
        Title,
        Message,
        OkButtonText,
        CancelButtonText,
        OnButtonClick,
    } = props;

    //const [tempOpen, setTempOpen] = React.useState(Open);

    const handleClose = (ButtonClicked: string) => {
        //alert(ButtonClicked + " clicked")
        //setTempOpen(false)
        OnButtonClick(ButtonClicked)
    };

    return (
        <div>
            <Dialog
                open={Open}
                TransitionComponent={Transition}
                keepMounted
                disableBackdropClick
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title"
                    disableTypography
                    style={{ fontWeight: "bold", fontSize: 16 }}>
                    {Title}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {Message}
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button
                        color="primary"
                        onClick={() => handleClose(OkButtonText)}>
                        {OkButtonText}
                    </Button>
                    {
                        CancelButtonText &&
                        <Button
                            color="default"
                            onClick={() => handleClose(CancelButtonText)}>
                            {CancelButtonText}
                        </Button>
                    }

                </DialogActions>
            </Dialog>
        </div>
    );
}

